import DennemeyerProvider from '../dennemeyer/DennemeyerProvider'
import { DennemeyerIpRightsProvider } from '../dennemeyer/new_way/IpRights'
import { DummyIpRightsProvider } from '../dummy/IpRights'
import { IpMetaContextProvider } from '../patent_renewal/IpMeta'
import { PRIpRightsProvider } from '../patent_renewal/IpRights'
import { useSettings } from './Settings'

export default function IpRightsProvider(props) {
  const { implementation } = useSettings()
  switch (implementation) {
    case 'dennemeyer':
      return <DennemeyerProvider> <DennemeyerIpRightsProvider {...props} /></DennemeyerProvider>
      case 'patent-renewal':
        return <IpMetaContextProvider><PRIpRightsProvider {...props} /></IpMetaContextProvider>
    case 'dummy':
      return <DummyIpRightsProvider {...props} />
    default:
      return null
  }
}